<div style="margin: 20px 0;">
{{if couponList.length}}
    {{each couponList item }}
        {{if item.IsValid && item.TicketType == 1}}
            <div class="coupon-item">
                <!--<span class="coupon-item-tip">{{item.TicketName}}</span>-->
                <img class="coupon-icon" src="../../../../public/images/coupon_icon.png">
                <div class="coupon-des">
                    <h1>{{item.FreeValue}}分钟</h1>
                    <span>可拨打{{item.FreeValue}}分钟免费咨询电话</span>
                </div>
                <div class="coupon-item-bottom">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    <div class="coupon-usage clearfix">
                        <span class="fl">{{item.EndTime}}过期</span>
                        <a class="fr useCoupon">去使用</a>
                    </div>
                </div>
            </div>
        {{else if !item.IsValid && item.TicketType == 1}}
            <div class="coupon-item gray">
                <!--<span class="coupon-item-tip">{{item.TicketName}}</span>-->
                <img class="coupon-icon" src="../../../../public/images/coupon_icon.png">
                <div class="coupon-des">
                    <h1>{{item.FreeValue}}分钟</h1>
                    <span>可拨打{{item.FreeValue}}分钟免费咨询电话</span>
                </div>
                <div class="coupon-item-bottom">
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    <div class="coupon-usage clearfix">
                        <span class="fl">{{item.EndTime}}过期</span>
                        <a class="fr">已过期</a>
                    </div>
                </div>
            </div>
        {{/if}}
    {{/each}}
{{else}}
    <div style="font-size: 16px;padding: 20px;text-align: center;">无优惠券</div>
{{/if}}
</div>

